import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../field.interface';
@Component({
  selector: 'c4dweb-date',
  template: `
    <ng-container *ngIf="group != null">
      <mat-form-field class="demo-full-width margin-top" [formGroup]="group">
        <input
          matInput
          [matDatepicker]="picker"
          [formControlName]="field.name"
          [placeholder]="field.label.toUpperCase()"
          (dateChange)="changeValue(field.name, $event)"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-hint></mat-hint>
        <ng-container
          *ngFor="let validation of field.validations"
          ngProjectAs="mat-error"
        >
          <!-- <mat-error *ngIf="!group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error> -->
        </ng-container>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="group == null">
      <mat-form-field class="demo-full-width margin-top">
        <input
          matInput
          [matDatepicker]="picker"
          [placeholder]="field?.label"
          [value]="field?.value"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-hint></mat-hint>
        <ng-container
          *ngFor="let validation of field.validations"
          ngProjectAs="mat-error"
        >
          <!-- <mat-error *ngIf="!group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error> -->
        </ng-container>
      </mat-form-field>
    </ng-container>
  `,
  styles: [],
})
export class C4dWebDateComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;

  @Output() eventChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}
  ngOnInit(): void {}

  changeValue(id, $event): void {
    let strValue = '';
    if (this.group != null) {
      strValue = this.group?.get(id)?.value;
    } else {
      strValue = $event;
    }
    const ret = {
      fieldId: id,
      value: strValue,
    };

    console.log('date change', ret);

    this.eventChange.emit(ret);
  }
}
